import { useCallback } from 'react';
import { useGlobalModals } from 'src/contexts/global-modals';

export const useRestartDevice = () => {
  const { restartDeviceModal, closeRestartDeviceModal } = useGlobalModals();

  const open = restartDeviceModal.opened;
  const isPending = false;

  const handleConfirm = useCallback(async () => {
    // TODO: Implement restart device API call
    console.log('[RestartDevice] Restarting device');
    closeRestartDeviceModal();
  }, [closeRestartDeviceModal]);

  const handleClose = useCallback(() => {
    closeRestartDeviceModal();
  }, [closeRestartDeviceModal]);

  return {
    handleClose,
    handleConfirm,
    isPending,
    open,
  };
};
